@if (withShell) {
<astral-field-shell [control]="control" [forId]="resolvedInputId" [helpText]="helpText">
  <div class="astral-typeahead__layout" [class.astral-typeahead__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
</astral-field-shell>
} @else {
  <div class="astral-typeahead__layout" [class.astral-typeahead__layout--with-supplemental-label]="!!resolvedSupplementalLabel">
    <ng-container [ngTemplateOutlet]="inputTemplate"></ng-container>
    <ng-container [ngTemplateOutlet]="supplementalLabelTemplate"></ng-container>
  </div>
}

<ng-template #inputTemplate>
  <div
    class="astral-typeahead"
    [class.astral-typeahead--readonly]="control?.isReadonly"
    [class.astral-typeahead--disabled]="control?.disabled"
    [class.astral-typeahead--focused]="isFocused"
  >
    <div class="astral-typeahead__actions">
      @if (showClearOthers) {
        <astral-field-action
        icon="clearOthers"
        titleKey="COMMON.CLEAR_OTHER_FILTERS"
        ariaLabelKey="COMMON.CLEAR_OTHER_FILTERS"
        (click)="clearAllOtherInputs()"
        ></astral-field-action>
      }

      @if (showClearThis) {
        <astral-field-action
        icon="clear"
        titleKey="COMMON.CLEAR"
        ariaLabelKey="COMMON.CLEAR"
        (click)="clearInput()"
        ></astral-field-action>
      }
    </div>

    <div
      cdkOverlayOrigin
      #overlayOrigin="cdkOverlayOrigin"
      #controlShell
      class="astral-typeahead__control-shell"
      [class.astral-typeahead__control-shell--readonly]="control?.isReadonly"
    >
      @if (control?.isReadonly) {
        <span class="astral-typeahead__readonly-icon" aria-hidden="true">
          <i [class]="readonlyIconClass"></i>
        </span>
      }

      <input
        #input
        astralFieldAccessibility
        class="astral-typeahead__control"
        type="text"
        role="combobox"
        [astralFieldControl]="control"
        [astralFieldHelpText]="helpText"
        [astralFieldInputId]="resolvedInputId"
        [attr.id]="resolvedInputId"
        [attr.name]="resolvedInputName"
        [attr.autocomplete]="'off'"
        aria-autocomplete="list"
        aria-haspopup="listbox"
        [attr.aria-controls]="resolvedInputId + '-panel'"
        [attr.aria-activedescendant]="activeOptionId"
        [attr.aria-expanded]="isPanelOpen && filteredItems.length ? 'true' : 'false'"
        [attr.placeholder]="resolvedPlaceholderText | translate"
        [disabled]="control?.disabled ? true : null"
        [readonly]="control?.isReadonly ? true : null"
        [required]="control?.required ? true : null"
        [value]="displayValue"
        (blur)="handleBlur()"
        (focus)="handleFocus()"
        (input)="handleInput($event)"
        (keydown)="handleInputKeydown($event)"
      />
    </div>
  </div>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="isPanelOpen && filteredItems.length > 0"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPush]="false"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayViewportMargin]="overlayViewportMargin"
  (overlayOutsideClick)="handleOverlayOutsideClick($event)"
  (positionChange)="handleOverlayPositionChange($event)"
>
  <div #panel class="astral-typeahead__panel" [class.astral-typeahead__panel--above]="isPanelAbove" [attr.id]="resolvedInputId + '-panel'" role="listbox">
    @for (item of filteredItems; track item; let index = $index) {
      <button
      #optionButton
      type="button"
      class="astral-typeahead__option"
      role="option"
      [attr.id]="optionId(index)"
      [attr.tabindex]="-1"
      [class.astral-typeahead__option--active]="index === activeOptionIndex"
      [attr.aria-selected]="control?.value === item"
      (mousedown)="handleOptionMouseDown($event)"
      (click)="selectItem(item)"
      >
        {{ getItemCaption(item, 'list') }}
      </button>
    }
  </div>
</ng-template>

<ng-template #supplementalLabelTemplate>
  @if (resolvedSupplementalLabel) {
    <span class="astral-typeahead__supplemental-label">
      {{ resolvedSupplementalLabel | translate }}
    </span>
  }
</ng-template>
